import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';
import {
  DriverInfoType,
  DriverInfoTypeParams,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDriverInfo/driverInfoQuery.type';
import { driverInfoQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDriverInfo/driverInfoQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getShowDriverInfoQueryOptions = (params: DriverInfoTypeParams) =>
  queryOptions({
    queryKey: ['get_show_driver_info', params],
    queryFn: () => driverInfoQueryFunction(params),
    select: (data: DriverInfoType) => {
      return {
        personal_information: [
          {
            label: 'جنسیت راننده :',
            value: data?.personal_information?.gender?.fa_const,
          },
          {
            label: 'نام :',
            value: data?.personal_information?.first_name,
          },
          {
            label: 'نام خانوادگی :',
            value: data?.personal_information?.last_name,
          },
          {
            label: 'تاریخ تولد :',
            value: convertTimestampToShamsi(
              Number(data?.certificate_information?.license_issue_date),
            ),
          },
          {
            label: 'تابعیت :',
            value: data?.personal_information?.driver_iranian
              ? 'ایرانی'
              : 'خارجی',
          },
          {
            label: 'کد ملی :',
            value: data?.personal_information?.national_code,
          },
          {
            label: 'نام پدر :',
            value: data?.personal_information?.father_name,
          },
          {
            label: 'شماره شناسنامه :',
            value: data?.personal_information?.identity_number,
          },
          {
            label: 'آیا راننده وسیله‌نقلیه مالک است ؟',
            value: data?.personal_information?.is_owner_driver ? 'بله' : 'خیر',
          },
        ],
        certificate_information: [
          {
            label: 'نوع گواهینامه :',
            value: data?.certificate_information?.license_type?.fa_name,
          },
          {
            label: 'شماره گواهینامه :',
            value: data?.certificate_information?.license_number,
          },
          {
            label: 'محل صدور گواهینامه :',
            value:
              data?.certificate_information?.license_issue_location_country
                ?.name,
          },
          {
            label: 'تاریخ صدور گواهینامه :',
            value: convertTimestampToShamsi(
              Number(data?.certificate_information?.license_issue_date),
            ),
          },
        ],
        contact_information: [
          {
            label: ' تلفن همراه :',
            value: data?.contact_information?.phone_number,
          },
          {
            label: ' تلفن ثابت :',
            value: data?.contact_information?.phone,
          },
          {
            label: 'کد پستی :',
            value: data?.contact_information?.postal_code,
          },
          {
            label: 'آدرس :',
            value: data?.contact_information?.address,
          },
        ],
      };
    },
  });
